<template>
    <div class="comResource">
        <div class="resource">
            <div class="">
                <div class="w1500">
                    <slot name="tle"></slot>
                    <div class="neirong">
                        <div class="w50 br-40 nr_tu" style="overflow: hidden;">

                            <div class="img1">
                                <img :src="resoulie[0].image" v-if="resoulie[0]" style="opacity: 0;">
                                
                            </div>

                            <div class="imglist">
                                <el-image @click="tiblq(index)" v-for="(item, index) in resoulie"  v-if="index<=2" :key="item.index" :src="item.image"
                                    fit="contain" :class="{ active: isActiveIndex == index }"></el-image>

                            </div>

                        </div>
                        <div class="w50 nr_wenzi ">
                            <div class="nr_ge cur_pointer" style="" v-for="(l, index) in resoulie"
                                @mouseover="isActiveIndex = index" @click="tiblq(index)" v-if="index<=2">
                                <a class="block">
                                    <div class="p1">
                                        <span class="nr_riqi ys-6 tit-18 montserLight">{{ l.createTime }}</span>
										<!-- 1video2blog3webinar -->
										<i>|</i>
										<span class=" ys-6 tit-18" v-if="l.type==1">video</span>
										<span class=" ys-6 tit-18" v-if="l.type==2">blog</span>
										<span class=" ys-6 tit-18" v-if="l.type==3">webinar</span>
                                        <!-- <slot name="tip"></slot> -->
                                    </div>
                                    <p class="nr_zi tit-24 montserRegular montserRegular">{{ l.title }}</p>
                                </a>
                            </div>
                        </div>
                    </div>
                    <slot name="btn"></slot>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
// import { resource } from '@/api/index.js';
import {Reblogtop,Rebloghot} from '@/api/resource.js';
export default {
    data() {
        return {
            isActive: true,
            isActiveIndex: 0,
			urlss:'',
            resoulie: [
				
            //     { tu: 'https://goodwe.hnydl.com.cn/gongyong/shangchuan/tu/33/2024/11/aiG4OVroUV4ZdUFvDv45IW9xIFD45v.png', createTime: '2024.10.14', description: 'GoodWe Lithium Battery Solutions For Advanced Residential Energy Storage' },
            //     { tu: 'https://goodwe.hnydl.com.cn/gongyong/shangchuan/tu/33/2024/11/Bid4O3Wj85lgGGi83WGkg5oWobdJIw.jpg', createTime: '2024.09.15', description: 'Comparativo de custos entre Galaxy GoodWe e módulos convencionais ' },
            //     { tu: 'https://goodwe.hnydl.com.cn/gongyong/shangchuan/tu/33/2024/11/w88nUL4kNsKkG0zn0x7nGp4jsUcXxS.jpg', createTime: '2024.09.15', description: 'GoodWe PLUS+ Pakistan: Energizing Installers with our Attractive Loyalty Program and Training Series' },
            
			],
        }
    },
    created() {
        // Reblogtop().then(shu => {
        // 	 console.log(shu)
        // 	 if(shu.code==200){
        // 		 this.resoulie=shu.data.homeMeasuresVO
        // 	 }
        // })
		Rebloghot().then(shu => {
        	 // console.log(shu)
        	 if(shu.code==200){
        		 this.resoulie=shu.data
                 
        	 }
        })
    },
    computed: {

    },
    methods: {
		tiblq(e){
            const routeMap = {
                1: 'video-details',
                2: 'blog-details',
                3: 'webinar-details'
            };
            
            const routeName = routeMap[this.resoulie[this.isActiveIndex].type];
            if(routeName) {
            this.$router.push({
                name: routeName,
                params: { id: this.resoulie[this.isActiveIndex].id }
            });
            }
			// if(this.resoulie[this.isActiveIndex].type==1){
			// 	this.urlss='/video-details?id=';
			// }else if(this.resoulie[this.isActiveIndex].type==2){
			// 	this.urlss='/blog-details?id=';
			// }else if(this.resoulie[this.isActiveIndex].type==3){
			// 	this.urlss='/webinar-details?id=';
			// }
			// this.$dakai(this.urlss+this.resoulie[this.isActiveIndex].id)
		}
    },
}
</script>
<style lang="scss" scoped>
.comResource {
    background: #fff;
}

.resource {
    .neirong {
        width: 100%;
        overflow: hidden;
        display: flex;
        align-items: center;
        flex-wrap: wrap;

        .el-image {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
			height: 100%;
            opacity: 0;
            transform: scale(1.1);
            transition: opacity 1s cubic-bezier(.435, .25, .15, .965), transform 1.5s cubic-bezier(.435, .25, .15, .965);
        }

        .el-image.active {
            opacity: 1;
            transform: scale(1);
        }
    }

    a::after {
        content: '';
        position: absolute;
        bottom: 0;
        left: 0;
        width: 0;
        height: 1px;
        background-color: #f43e3c;
        transition: all 0.56s ease-in-out;
    }

    a:hover p {
        color: #f43e3c;
    }

    a:hover::after {
        width: 100%;
    }

    .el-button {
        padding: .16rem .4rem;
        background: linear-gradient(87deg, #ff785c 0%, #e70a16 100%);
        border-radius: 28px;
        border-color: unset;
    }

    .biaoti {
        font-family: "montserBold";
        padding: .5rem 0 .8rem;
    }

    .el-image,
    img {
        width: 100%;
		min-height: 5rem;
        transition: all 0.6s ease-out;
    }

    .nr_tu {
        float: left;
        cursor: pointer;
        position: relative;
    }

    .nr_tu:hover .el-image {
        transform: scale(1.06);
    }

    .nr_wenzi {
        float: right;
        padding-left: .7rem;
        box-sizing: border-box;
    }

    .nr_wenzi {
        .p1 {
            font-family: "montserLight";

            i {
                color: #999999;
                margin: 0 .1rem;
            }
        }
    }

    .nr_zi {
        margin-top: 0.1rem;
        transition: all 0.36s ease-in-out;
        line-height: 1.55;
        color: #333;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        overflow: hidden;
    }

    a {
        text-decoration: none;
        position: relative;
        border-bottom: 1px solid #f5f5f5;
        padding: .3rem 0 .4rem;
    }

    .anniu {
        button {
            font-family: "montserLight";
        }
    }
}



// ==========================================================================================================================================================================
// 响应式

@media screen and (max-width: 1024px) {
    .resource .nr_tu {width: 60%;}
    .resource .nr_wenzi {width: 40%;}
}

@media screen and (max-width: 767px) {
    .resource .nr_tu {width: 100%;}
    .resource .nr_wenzi {width: 100%; padding-left: 0; margin-top: .3rem;}

}



</style>
